// Copyright (c) 2020 Deere & Company

/**
 * Get the base path for ATP AWS Batch Service based on the current hostname
 * This is separate from the main ATP service path
 */
export const getBatchBasePath = () => {

    const domain = window.location.hostname;

    const batchBasePathMapper = {
        // AWS DevL Environment
        'atp-devl.deere.com': '//om-ofp-atp-batch-app.om-comar-apps-devl-vpn.us.i26.c01.johndeerecloud.com',
        
        // AWS Qual Environment
        'atpqual.tal.deere.com': '//om-ofp-atp-batch-app.om-comar-apps-devl-vpn.us.i26.c01.johndeerecloud.com',
        'atp-qual.deere.com': '//om-ofp-atp-batch-app.om-comar-apps-devl-vpn.us.i26.c01.johndeerecloud.com',
        
        
        // AWS Prod Environment
        'atp.deere.com': '//om-ofp-atp-batch-app.om-comar-apps-prod-vpn.us.i26.c01.johndeerecloud.com',
        'atp-prod.deere.com': '//om-ofp-atp-batch-app.om-comar-apps-prod-vpn.us.i26.c01.johndeerecloud.com',
        
        // Local development - use proxy (empty string)
        //localhost: '',
        // localhost: 'http://localhost:8080',
         localhost: '//om-ofp-atp-batch-app.om-comar-apps-devl-vpn.us.i26.c01.johndeerecloud.com'
    };

    return batchBasePathMapper[domain] ? batchBasePathMapper[domain] : batchBasePathMapper.localhost;

};
